export const SequentialIcon  =  () => {
   return <svg style={{paddingTop: 2}} width={14}  height={14} focusable="false" aria-hidden="true" viewBox="0 0 24 24"><path d="M15 16v1.26l-6-3v-3.17L11.7 8H16V2h-6v4.9L7.3 10H3v6h5l7 3.5V22h6v-6zM12 4h2v2h-2zM7 14H5v-2h2zm12 6h-2v-2h2z"></path></svg>
}
export default SequentialIcon;